var map = {
	"./column-scroll": 17,
	"./column-scroll.js": 17,
	"./core": 18,
	"./core.js": 18,
	"./default-elements": 19,
	"./default-elements.js": 19,
	"./feature-list": 20,
	"./feature-list.js": 20,
	"./gallery-wall": 21,
	"./gallery-wall.js": 21,
	"./headings": 26,
	"./headings.js": 26,
	"./page-bg": 22,
	"./page-bg.js": 22,
	"./pointer-indicator": 23,
	"./pointer-indicator.js": 23,
	"./team-member-card": 24,
	"./team-member-card.js": 24,
	"./triggers": 25,
	"./triggers.js": 25
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 133;